import { Button } from '@chakra-ui/react';
import React from 'react';

interface SubnavBackButtonProps {
  className?: string;
  onClick: () => void;
  label: string;
}

const ButtonStyles = {
  display: { laptop: 'none' },
  paddingX: 6,
  paddingY: 0,
  width: 'full',
  height: 12,
  fontSize: '13px',
  textAlign: 'left',
  _hover: {
    color: 'wl-darkBlue.rgb',
    background: 'wl-lightBlue.rgba10',
  },
};

const SubnavBackButton: React.FC<SubnavBackButtonProps> = ({
  className,
  onClick,
  label,
}) => {
  return (
    <Button
      className={className}
      variant="ghost"
      onClick={onClick}
      sx={ButtonStyles}
    >
      {label}
    </Button>
  );
};

export default SubnavBackButton;
